import React, { useEffect } from 'react';
import { contentHeaderAtom } from 'Recoil/header.atom';
import { useRecoilState } from 'recoil';
import { isNil } from 'lodash';

const useAddContentHeader = (contentHeader: React.ReactNode, isLoading: boolean) => {
  const [, setContentHeaderAtom] = useRecoilState<React.ReactNode | null>(contentHeaderAtom);

  useEffect(() => {
    return () => { setContentHeaderAtom(null) }
  }, [])

  useEffect(() => {
    if (!isNil(contentHeader)) {
      setContentHeaderAtom(contentHeader)
    }
  }, [isLoading]);
}

export default useAddContentHeader;
